import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { UsernameService } from '../../../services/username/username.service';

@Component({
  selector: 'app-recover-username',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    CommonModule,
    RouterModule,
  ],
  templateUrl: './recover-username.component.html',
  styleUrl: './recover-username.component.scss'
})
export class RecoverUsernameComponent {
  private fb = inject(FormBuilder);

  form: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    ssnLast4: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]],
    dateOfBirth: ['', Validators.required]
  });

  errorMessage = '';
  successMessage = '';
  isSubmitting = false;

  constructor(
    private router: Router,
    private usernameService: UsernameService,
  ) {}

  onSubmit(): void {
    if (!this.form.valid || this.isSubmitting) return;

    this.isSubmitting = true;
    this.errorMessage = '';
    this.successMessage = '';

    const { email, ssnLast4, dateOfBirth } = this.form.value;

    this.usernameService.recoverUsername(email, ssnLast4, dateOfBirth).subscribe({
      next: () => {
        // Keep responses generic to avoid account enumeration
        this.successMessage = 'If the information matches our records, your username has been emailed.';
        this.isSubmitting = false;
        setTimeout(() => this.router.navigate(['/login']), 3000);
      },
      error: (error) => {
        // Mirror forgot password behavior: generic message
        this.errorMessage = error?.error?.message || 'If the information matches our records, your username has been emailed.';
        this.isSubmitting = false;
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/login']);
  }
}
